export default __webpack_public_path__ + "images/Axial_View_of_Kidneys_dark.da08063f7fecfe2957f5ca60d0dbfd97.png";